import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import tools from './tools/index';
import messages from './messages';
import unSentMessages from './unSentMessages';
import loading from './loading';
import escalationRecommendation from './escalationRecommendation';
import buttons from './buttons';
import analyticsTracker from './analyticsTracker';
import sounds from './sounds';
import scrollTracking from './scrollTracking';
import popups from './popups';
import centerPane from './centerPane';
import appVersion from './appVersion';
import userSettings from './userSettings';
import display from './display';
import displayingHistoricalConversation from './displayingHistoricalConversation';
import previousConversationSection from './previousConversationSection';
import chatAlertActive from './chatAlertActive';
import conversationRatings from './conversationRatings';
import chatUI from './chatUI';
import conversationAttachmentsSection from './conversationAttachmentsSection';

const uiPersistConfig = {
  key: 'export-portal-ui',
  storage,
  whitelist: ['messages', 'scrollTracking', 'conversationRatings', 'userSettings'],
};

const uiReducer = combineReducers({
  tools,
  messages,
  loading,
  buttons,
  unSentMessages,
  escalationRecommendation,
  analyticsTracker,
  sounds,
  scrollTracking,
  popups,
  centerPane,
  appVersion,
  userSettings,
  display,
  displayingHistoricalConversation,
  previousConversationSection,
  chatAlertActive,
  conversationRatings,
  chatUI,
  conversationAttachmentsSection,
});

export default persistReducer(uiPersistConfig, uiReducer);
